export const suppliersFaq = [
    {
        title: "What types of businesses can benefit from TrackSellers?",
        content: "TrackSellers is designed for manufacturers, suppliers, and distributors who sell to Amazon sellers, providing valuable insights and tools to help grow their businesses and stay ahead of the competition."
    },
    {
        title: "Can I customize my search criteria to find relevant leads in my industry?",
        content: "Yes, TrackSellers' Advanced Seller Search allows you to filter sellers based on various attributes, such as category, location, and sales volume, ensuring that you find the most relevant leads for your business."
    },
    {
        title: "How does TrackSellers help me stay informed about market trends and competition?",
        content: "TrackSellers provides comprehensive insights into seller performance, market trends, and competitive landscapes, empowering you to make informed decisions, adapt your strategies, and stay ahead of the competition."
    },
    {
        title: "Can TrackSellers help me identify new partnership opportunities?",
        content: "Yes, with detailed information on millions of Amazon sellers and their business performance, you can identify potential partnership opportunities that align with your business objectives and growth strategies."
    },
    {
        title: "Is there a limit to the number of leads I can generate using TrackSellers?",
        content: "There is no strict limit on the number of leads you can generate with TrackSellers. Our platform is designed to cater to businesses of all sizes and can accommodate lead lists ranging from 1,000 to 35,000, depending on your subscription plan."
    },
    {
        title: "Can I try TrackSellers before committing to a subscription plan?",
        content: "Yes, TrackSellers offers a free trial that allows you to explore our platform's features and benefits before committing to a subscription. Sign up today to experience the power of TrackSellers for your business."
    }
]

